export const DEFAULT_IDE_EXPERIENCE = {
  enableZoomControls: true,
  enableFullscreenWorkspace: true,
  enableTapToFocusKeyboard: true,
  stickyConsoleActionsInFullscreen: true,
  compactMobileLayout: true,
};

export function normalizeIdeExperience(value = {}) {
  const raw = value && typeof value === 'object' ? value : {};
  return {
    enableZoomControls: raw.enableZoomControls !== false,
    enableFullscreenWorkspace: raw.enableFullscreenWorkspace !== false,
    enableTapToFocusKeyboard: raw.enableTapToFocusKeyboard !== false,
    stickyConsoleActionsInFullscreen: raw.stickyConsoleActionsInFullscreen !== false,
    compactMobileLayout: raw.compactMobileLayout !== false,
  };
}
